import {assert} from 'assert-ts';
import type {Metadata} from '../types';

export function getManifestationExpressionId(
  data: Metadata,
  manifestationId: string,
): string {
  const expressionId = data.manifestations.find(
    m => m.id === manifestationId,
  )?.expressionId;
  return assert(
    expressionId,
    'getManifestationExpressionId: unknownmanifestationId',
    {manifestationId},
  );
}
